module.exports = __webpack_public_path__ + "static/media/background@2x.c4d97277.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/background@2x.jpg
// module id = 143
// module chunks = 0